import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Portal } from 'react-portal';
import { Formik } from 'formik';

import preventDefaultPropagation from 'client/helpers/preventDefaultPropagation';
import sendDataToMobileApp, {
  SR_MOBILE_APP_ACTION_TYPE_RATE_APP,
} from 'client/helpers/sendDataToMobileApp';

import {
  SR_API_ACTION_ADD_MOBILE_APP_USER_COMMENT,
  SR_API_ACTION_UPDATE_USER_SETTINGS,
} from 'api/actionTypes';

import SrAgentLeadHighFiveModal from 'client/components/SrAgentLeadHighFiveModal';
import SrFormikField from 'client/components/SrFormikField';
import SrDialogBox from 'client/components/SrDialogBox';
import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';

import branch from 'client/core/branch';
import withApiState from 'client/helpers/withApiState';
import postWithState from 'client/actions/postWithState';
import UserActions from 'client/actions/User';
import MobileAppActions from 'client/actions/MobileApp';

const SCREEN_ASK_FOR_REVIEW = 'SCREEN_ASK_FOR_REVIEW';
const SCREEN_WRITE_COMMENT = 'SCREEN_WRITE_COMMENT';
const SCREEN_COMMENT_SENT = 'SCREEN_COMMENT_SENT';

@withApiState({
  addMobileAppUserCommentApiState: {
    action: SR_API_ACTION_ADD_MOBILE_APP_USER_COMMENT,
  },
  updateUserSettingsApiState: {
    action: SR_API_ACTION_UPDATE_USER_SETTINGS,
  },
})
@branch({
  appUrl: ['env', 'APP_URL'],
  isPartnerApp: ['mobileApp', 'isPartnerApp'],
})
class SrAppStoreReviewDialog extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
    addMobileAppUserCommentApiState: PropTypes.object,
    updateUserSettingsApiState: PropTypes.object,
    appUrl: PropTypes.string.isRequired,
    isPartnerApp: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      currentScreen: null,
    };

    this._unmounting = false;
  }

  componentDidMount() {
    setTimeout(this._showDialog, 5 * 1000);
  }

  componentWillUnmount() {
    this._unmounting = true;
    global.document.body.classList.remove('no-scrolling');
  }

  _showDialog = () => {
    if (!this._unmounting) {
      global.document.body.classList.add('no-scrolling');
      this.setState({ currentScreen: SCREEN_ASK_FOR_REVIEW });
    }
  };

  _onShowGiveFeedbackDialog = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ currentScreen: SCREEN_WRITE_COMMENT });
  };

  _onSendFeedback = (values) => {
    const { dispatch, currentUser } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_ADD_MOBILE_APP_USER_COMMENT,
      payload: {
        comment: values.comment,
        userId: currentUser.id,
      },
      onSuccess: () => {
        this.setState({ currentScreen: SCREEN_COMMENT_SENT });
        setTimeout(this._updateAskedForAppStoreReviewSetting, 1800);
      },
    });
  };

  _onRateMobileApp = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this._updateAskedForAppStoreReviewSetting();

    sendDataToMobileApp({
      actionType: SR_MOBILE_APP_ACTION_TYPE_RATE_APP,
    });
  };

  _updateAskedForAppStoreReviewSetting = () => {
    const { dispatch, isPartnerApp } = this.props;
    const fieldId = isPartnerApp ? 'askedForPartnerAppStoreReview' : 'askedForAppStoreReview';

    dispatch(UserActions.updateSettings, {
      [fieldId]: true,
    });

    this._closeDialog();
  };

  _closeDialog = () => {
    const { dispatch } = this.props;
    dispatch(MobileAppActions.closeAskForReviewDialog);
  };

  render() {
    const { currentScreen } = this.state;
    const { appUrl } = this.props;

    if (currentScreen === SCREEN_ASK_FOR_REVIEW) {
      return (
        <SrDialogBox
          isOpen
          title="Do you enjoy using Sunroom?"
          actions={[
            {
              id: 'no',
              text: 'No',
              onClick: this._onShowGiveFeedbackDialog,
            },
            {
              id: 'yes',
              text: 'Yes',
              onClick: this._onRateMobileApp,
            },
          ]}
          onClose={() => {}}
        />
      );
    }
    if (currentScreen === SCREEN_WRITE_COMMENT) {
      const { addMobileAppUserCommentApiState, updateUserSettingsApiState } = this.props;
      const apiStateInProgress =
        addMobileAppUserCommentApiState.inProgress || updateUserSettingsApiState.inProgress;

      return (
        <Portal>
          <div className={classnames('darkModal', 'darkNavigator', 'webview')}>
            <div className="SrAppStoreReviewDialog" onClick={preventDefaultPropagation}>
              <div className="content">
                <div className="header">
                  <span className="title">give feedback</span>
                  <span className="description">
                    We'd love to get your feedback.
                    <br />
                    How should we improve Sunroom? The more details, the better. Thank you!
                  </span>
                  <div className="closeIcon" onClick={this._closeDialog} />
                </div>
                <Formik
                  enableReinitialize
                  validateOnChange
                  initialValues={{
                    comment: '',
                  }}
                  onSubmit={this._onSendFeedback}
                  render={(formikBag) => {
                    return (
                      <form className="form">
                        <SrFormikField
                          formField={{
                            id: 'comment',
                            type: 'long_text',
                            properties: {
                              placeholder: 'Write here...',
                            },
                          }}
                          formikBag={formikBag}
                        />
                        <ButtonDeprecated
                          theme={BUTTON_THEME_BLUE}
                          disabled={!formikBag.values.comment || apiStateInProgress}
                          onClick={formikBag.handleSubmit}
                        >
                          send feedback
                        </ButtonDeprecated>
                      </form>
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </Portal>
      );
    }
    if (currentScreen === SCREEN_COMMENT_SENT) {
      return (
        <div className="modal success confirm app-store-review">
          <div className="contentContainer">
            <div className="highFiveAnimationContainer">
              <SrAgentLeadHighFiveModal appUrl={appUrl} />
            </div>
            <div className="textContainer">
              <span className="headline">Thanks, you're awesome!</span>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
}

SrAppStoreReviewDialog.displayName = 'SrAppStoreReviewDialog';

export default SrAppStoreReviewDialog;
